import { render, staticRenderFns } from "./QuotaLine.vue?vue&type=template&id=282b9b14&scoped=true&"
import script from "./QuotaLine.vue?vue&type=script&lang=ts&"
export * from "./QuotaLine.vue?vue&type=script&lang=ts&"
import style0 from "./QuotaLine.vue?vue&type=style&index=0&id=282b9b14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282b9b14",
  null
  
)

export default component.exports